/* istanbul ignore file */

import styled, { css } from 'styled-components';
import { LoadingIcon } from '@chegg-ui/theme';
export var PaddingContainer = styled.div.withConfig({
  componentId: "sc-1wuf5r4-0"
})(["", ""], function (_ref) {
  var top = _ref.top,
    right = _ref.right,
    bottom = _ref.bottom,
    left = _ref.left,
    backgroundColor = _ref.backgroundColor;
  return css(["padding:", "px ", "px ", "px ", "px;background-color:", ";"], top || 0, right || 0, bottom || 0, left || 0, backgroundColor);
});
export var OneClickLoader = styled(LoadingIcon).withConfig({
  componentId: "sc-1wuf5r4-1"
})(["position:absolute;left:calc(50% - 24px);top:calc(50% - 24px);"]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/components/common/styled.js
// module id = 384
// module chunks = 11